/* eslint-disable eqeqeq */
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SearchExistingVisitorInfoCard from "../../../components/card/SearchExistingVisitorInfoCard";
import VisitorDetailsCard from "../../../components/card/VisitorDetailsCard";
import VisitDetailsCard from "../../../components/card/VisitDetailsCard";
import AttachmentsCard from "../../../components/card/AttachmentsCard";
import { Button } from "../../../components/button";
import useFormWithSchema from "../../../hooks/useFormWithSchema";
import {
  useGetAppointmentById,
  useGetFileByTypeQuery,
} from "../../../hooks/visitor/query";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fileToBase64,
  formattedDate,
  formattedDateTime,
  isVisitWithinVisitingHours,
  mapToOptions,
  onlyDate,
} from "../../../lib/functions";
import {
  AddAttachments,
  API_ERRORS,
  ATTACHMENTS_TYPE,
  Device,
  DOC_TYPE_ID,
  DYNAMIC_WORKFLOW,
  IndividualData,
  INVALID_PHOTO_ERRORS,
  STATUS_IDS,
  USER_ROLES_IDS,
  UserAppointment,
  VISIT_CREATED_FROM,
  VISIT_REQUEST_VIEW_TYPE,
  VisitorType,
} from "../../../constants/common";
import useAuthStore from "../../../store/Auth";
import {
  useAddAttachment,
  useAddVisitorAppointment,
  useApproveDevice,
  useCheckDuplicateAppointment,
  useRemoveAppointmentAttachment,
  useGetDeviceDetailsById,
  useUpdateVisitorAppointment,
  useValidatePhoto,
} from "../../../hooks/visitor/mutation";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../components/loader";
import { APP_ROUTES } from "../../../routes";
import RejectAppointmentModal from "../../../components/modal/RejectAppointmentModal";
import ApproveAppointmentModal from "../../../components/modal/ApproveAppointmentModal";
import { ApproveAppointmentBody } from "../../../hooks/visitor/interface";
import { createIndividualSchema } from "../../../schemas/individualSchema";
import DeviceDetailsCard from "../../../components/card/DeviceDetailsCard";
import RequestMoreInfoModal from "../../../components/modal/RequestMoreInfoModal";
import BackButton from "../../../components/button/BackButton";
import {
  useGetAllVisitPurposesDropdown,
  useGetDynamicWorkflowsByIdByNonAdmin,
  useGetValidatePhoto,
  useGetVisitingHours,
} from "../../../hooks/common/query";
import CommentsDrawer from "../../../components/drawer/CommentsDrawer";
import { Check, CircleAlert, X } from "lucide-react";
import { cn } from "../../../utils/cn";
import VehicleInformationCard from "../../../components/card/VehicleInformationCard";
import CheckboxInput from "../../../components/inputs/CheckboxInput";

const Individual = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const user = useAuthStore((state) => state.user);

  const [isHostAccompanyPledge, setIsHostAccompanyPledge] = useState(false);
  const [isMobileAllowed, setIsMobileAllowed] = useState(false);
  const [isLaptopAllowed, setIsLaptopAllowed] = useState(false);

  const [isDeviceDetails, setIsDeviceDetails] = useState(true);

  const [isRequestMoreInfoModalOpen, setIsRequestMoreInfoModalOpen] =
    useState(false);

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const key = searchParams.get("ID");
  const viewType = searchParams.get("type");

  const { data: appointment, isPending: isAppointmentLoading } =
    useGetAppointmentById({
      encryptedId: key || "",
    });

  const [, setComments] = useState([]);

  const [userAppointmentDetails, setUserAppointmentDetails] =
    useState<UserAppointment>();

  const [existingVisitorAppointment, setExistingVisitorAppointment] =
    useState<any>();

  const { data: allVisitPurposes } = useGetAllVisitPurposesDropdown({
    encryptedVisitRequestTypeID: "",
    encryptedId: userAppointmentDetails?.visitPurpose
      ? userAppointmentDetails?.visitPurpose.toString()
      : "",

    // encryptedVisitRequestTypeID: selectedVisitReqType
    //   ? encrypt(selectedVisitReqType.toString())
    //   : userAppointmentDetails?.visitReqType
    //   ? encrypt(userAppointmentDetails?.visitReqType?.toString())
    //   : "",
  });

  const visitPurposes = useMemo(
    () =>
      mapToOptions(
        "s_PurposeEn",
        "s_PurposeAr",
        "n_PurposeID",
        allVisitPurposes
      ),
    [allVisitPurposes]
  );

  const [isVehicleInfoVisible, setIsVehicleInfoVisible] = useState(false);

  const [isAttachments, setIsAttachments] = useState({
    havePhoto: 0,
    haveIqama: 0,
    haveEid: 0,
    havePassport: 0,
    haveOthers: 0,
    haveVisa: 0,
    haveVehicleRegistration: 0,
    haveHostEmployeeCard: 0,
  });

  const [removedAttachments, setRemovedAttachments] = useState<
    Array<{ S_FileFieldName: string; s_FiledFileType: string }>
  >([]);

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    clearErrors,
  } = useFormWithSchema(
    createIndividualSchema(isAttachments, visitPurposes, user?.n_RoleID),
    {
      reValidateMode: "onChange",
      defaultValues: {
        hostEmail: user?.email,
        idType: DOC_TYPE_ID.NATIONAL_ID,
        visitStartDate:
          new Date() > new Date(new Date().setHours(7, 0, 0, 0))
            ? formattedDateTime(new Date())
            : formattedDateTime(new Date(new Date().setHours(7, 0, 0, 0))),
        visitEndDate: formattedDateTime(
          new Date(
            (new Date() > new Date(new Date().setHours(7, 0, 0, 0))
              ? new Date()
              : new Date(new Date().setHours(7, 0, 0, 0))
            ).getTime() +
              60 * 60 * 1000
          )
        ),
      },
      context: {
        isVehicleInfoVisible,
        selectedIdType: DOC_TYPE_ID.NATIONAL_ID,
      },
    }
  );

  const selectedIdType = watch("idType");
  const visitReqType = watch("visitReqType");
  const visitStartDate = new Date(watch("visitStartDate") || "");
  const visitEndDate = new Date(watch("visitEndDate") || "");

  // const isMultiDayVisit =
  //   visitStartDate instanceof Date &&
  //   visitEndDate instanceof Date &&
  //   !isNaN(visitStartDate.getTime()) &&
  //   !isNaN(visitEndDate.getTime()) &&
  //   Math.floor(
  //     (visitEndDate.getTime() - visitStartDate.getTime()) /
  //       (1000 * 60 * 60 * 24)
  //   ) >= 1;

  const isApprovalReq = useMemo(
    () => location.pathname === APP_ROUTES.APPROVE_REQUEST,
    [location.pathname]
  );

  const { mutateAsync: ApproveDevices, isPending: isApproveDevicesLoading } =
    useApproveDevice();

  const uploadPhotoRef = useRef<HTMLInputElement | null>(null);
  const uploadEidRef = useRef<HTMLInputElement | null>(null);
  const uploadPassportRef = useRef<HTMLInputElement | null>(null);
  const uploadVehicleRegLicenseRef = useRef<HTMLInputElement | null>(null);
  const uploadHostEmployeeCardRef = useRef<HTMLInputElement | null>(null);
  const uploadIqamaRef = useRef<HTMLInputElement | null>(null);
  const uploadIdOtherRef = useRef<HTMLInputElement | null>(null);
  const uploadVisaRef = useRef<HTMLInputElement | null>(null);

  const [photoFileName, setPhotoFileName] = useState("");
  const [photoFileType, setPhotoFileType] = useState("");

  const [eidFileName, setEidFileName] = useState("");
  const [eidFileType, setEidFileType] = useState("");

  const [passportFileName, setPassportFileName] = useState("");
  const [passportFileType, setPassportFileType] = useState("");

  const [iqamaFileName, setIqamaFileName] = useState("");
  const [iqamaFileType, setIqamaFileType] = useState("");

  const [idOtherFileName, setIdOtherFileName] = useState("");
  const [idOtherFileType, setIdOtherFileType] = useState("");

  const [visaFileName, setVisaFileName] = useState("");
  const [visaFileType, setVisaFileType] = useState("");

  const [addedDevices, setAddedDevices] = useState<Device[]>();

  const [vehicleRegLicenseFileName, setVehicleRegLicenseFileName] =
    useState("");
  const [vehicleRegLicenseFileType, setVehicleRegLicenseFileType] =
    useState("");

  const [hostEmployeeCardFileName, setHostEmployeeCardFileName] = useState("");
  const [hostEmployeeCardFileType, setHostEmployeeCardFileType] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  // const isVisitExpired = useMemo(
  //   () => isExpired(new Date(appointment?.appointment?.dt_AppointmentEndTime)),
  //   [appointment?.appointment?.dt_AppointmentEndTime]
  // );

  const { data: visitingHours } = useGetVisitingHours();

  const visitAllowedDuration = visitingHours?.visitorsMaxAllowedDays - 1;

  const [persistedDevices, setPersistedDevices] = useState([]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      toast.error(t("fillAllInfo"));
    }
  }, [errors, t]);

  useEffect(() => {
    setRemovedAttachments([]);
  }, [appointment]);

  useEffect(() => {
    let fetchedAppointmentDetails;
    let fetchedVehicleDetails;

    if (appointment) {
      fetchedAppointmentDetails = appointment?.appointment;
      fetchedVehicleDetails = appointment?.vehicle;
      setComments(appointment?.appointmentComments);
    } else {
      fetchedAppointmentDetails = existingVisitorAppointment?.appointment;
      fetchedVehicleDetails = existingVisitorAppointment?.vehicle;
    }

    if (appointment || existingVisitorAppointment) {
      const userData = {
        id: fetchedAppointmentDetails?.n_AppointmentID,
        name:
          fetchedAppointmentDetails?.s_FullName ||
          fetchedAppointmentDetails?.s_VisitorName_En,
        companyName:
          fetchedAppointmentDetails?.s_CompanyName ||
          fetchedAppointmentDetails?.s_Sponsor,
        nationality: fetchedAppointmentDetails?.nationality,
        number: fetchedAppointmentDetails?.s_MobileNo,
        email:
          fetchedAppointmentDetails?.s_Email ||
          fetchedAppointmentDetails?.visitorEmail,

        idType: fetchedAppointmentDetails?.n_DocumentType,

        iqama: fetchedAppointmentDetails?.s_Iqama,
        iqamaExpiryDate: fetchedAppointmentDetails?.dt_IqamaExpiry,

        eid: fetchedAppointmentDetails?.eidNumber,
        eidExpiryDate:
          fetchedAppointmentDetails?.dt_EIDExpiryDate &&
          formattedDate(new Date(fetchedAppointmentDetails?.dt_EIDExpiryDate)),

        passportNumber: fetchedAppointmentDetails?.passportNumber,
        passportExpiryDate:
          fetchedAppointmentDetails?.dt_PassportExpiryDate &&
          formattedDate(
            new Date(fetchedAppointmentDetails?.dt_PassportExpiryDate)
          ),

        idTypeOtherName: fetchedAppointmentDetails?.s_OthersDoc,
        idTypeOtherNumber: fetchedAppointmentDetails?.s_OthersValue,
        idTypeOtherExpiryDate: fetchedAppointmentDetails?.dt_OthersExpiry,

        visa: fetchedAppointmentDetails?.s_VisaNo,
        visaExpiryDate:
          fetchedAppointmentDetails?.dt_VisaExpiryDate &&
          formattedDate(new Date(fetchedAppointmentDetails?.dt_VisaExpiryDate)),

        dateOfBirth:
          fetchedAppointmentDetails?.dt_DateOfBirth &&
          formattedDate(new Date(fetchedAppointmentDetails?.dt_DateOfBirth)),

        plateSource: fetchedVehicleDetails?.n_PlateSource,
        plateCode: fetchedVehicleDetails?.s_PlateCode,
        plateNumber: fetchedVehicleDetails?.s_PlateNumber,
        plateLetter1: fetchedVehicleDetails?.n_PlateLetter1,
        plateLetter2: fetchedVehicleDetails?.n_PlateLetter2,
        plateLetter3: fetchedVehicleDetails?.n_PlateLetter3,

        location: fetchedAppointmentDetails?.n_LocationID,
        visitingDepartment: fetchedAppointmentDetails?.n_DepartmentID,
        gate: fetchedAppointmentDetails?.n_GateID,
        meetingRoom: fetchedAppointmentDetails?.n_MeetingRoomID,
        building: fetchedAppointmentDetails?.n_BuildingID,
        visitReqType: fetchedAppointmentDetails?.n_VisitType,
        visitPurpose: fetchedAppointmentDetails?.purpose,
        visitPurposeOther: fetchedAppointmentDetails?.purposeOtherValue,
        hostEmail: fetchedAppointmentDetails?.s_VisitingPersonEmail,
        hostMobileNumber: fetchedAppointmentDetails?.s_HostMobileNo,
        visitStartDate: fetchedAppointmentDetails?.dt_AppointmentStartTime,
        visitEndDate: fetchedAppointmentDetails?.dt_AppointmentEndTime,
        vehicleNo: fetchedAppointmentDetails?.s_VehicleNo,
        note: fetchedAppointmentDetails?.s_Remarks,
        accessGroup: fetchedAppointmentDetails?.n_AccessGroupID,

        uploadPhoto: fetchedAppointmentDetails?.s_Photos,
        uploadEid: fetchedAppointmentDetails?.s_EIDFile,
        uploadPassport: fetchedAppointmentDetails?.s_PassportFile,
        uploadVehicleRegLicense:
          fetchedAppointmentDetails?.s_VehicleRegistrationFile,
        uploadVisa: fetchedAppointmentDetails?.s_VisaFile,

        isMobileAllowed: fetchedAppointmentDetails?.n_IsMobileAllowed,
        isLaptopAllowed: fetchedAppointmentDetails?.n_IsLaptopAllowed,
        devices: fetchedAppointmentDetails?.devices,
        nextDevicesApproverRoleId:
          fetchedAppointmentDetails?.n_NextDevicesApproverRoleId,
        devicesApprovalStatus:
          fetchedAppointmentDetails?.n_DevicesApprovalStatus,
        isExternalAppointment:
          fetchedAppointmentDetails?.n_IsExternalAppointment,
        isVehicleAllowed:
          fetchedAppointmentDetails?.n_IsVehicleAllowed === 1
            ? true
            : fetchedAppointmentDetails?.n_IsVehicleAllowed === 0
            ? false
            : undefined,
        approvalStatus: fetchedAppointmentDetails?.approvalStatus,

        currentApproverOrderNo:
          fetchedAppointmentDetails?.n_CurrentApproverOrderNo,
      };
      setUserAppointmentDetails(userData);

      if (!fetchedVehicleDetails) {
        setIsVehicleInfoVisible(false);
      } else {
        setIsVehicleInfoVisible(true);
      }

      if (appointment) {
        setIsAttachments({
          havePhoto: fetchedAppointmentDetails?.havePhoto,
          haveEid: fetchedAppointmentDetails?.haveEid,
          havePassport: fetchedAppointmentDetails?.havePassport,
          haveVehicleRegistration:
            fetchedAppointmentDetails?.haveVehicleRegistration,
          haveIqama: fetchedAppointmentDetails?.haveIqama,
          haveOthers: fetchedAppointmentDetails?.haveOthers,
          haveVisa: fetchedAppointmentDetails?.haveVisa,
          haveHostEmployeeCard: fetchedAppointmentDetails?.haveHostEmployeeCard,
        });
      }

      setIsMobileAllowed(userData?.isMobileAllowed ? true : false);
      setIsLaptopAllowed(userData?.isLaptopAllowed ? true : false);

      const fetchedDevices = userData?.devices?.map((item: Device) => ({
        ...item,
        purpose: item.purpose,
        deviceTypeOther: item.deviceTypeOthersValue,
        devicePurposeOther: item.devicePurposeOthersValue,
      }));
      setAddedDevices(fetchedDevices);

      setPersistedDevices(fetchedDevices);
      setIsDeviceDetails(userData?.devices?.length > 0);

      if (userData) {
        setValue("name", userData?.name || "");
        setValue("companyName", userData?.companyName || "");
        setValue("nationality", userData?.nationality || "");
        setValue("number", userData?.number || "");
        setValue("email", userData?.email || "");

        setValue(
          "dateOfBirth",
          userData?.dateOfBirth
            ? formattedDate(new Date(userData.dateOfBirth))
            : ""
        );

        setValue("idType", userData?.idType || null);

        userData?.iqama && setValue("iqama", userData?.iqama);
        new Date(userData?.iqamaExpiryDate) >= new Date() ||
        location?.pathname !== APP_ROUTES.INDIVIDUAL_VISIT_REQUEST
          ? setValue("iqamaExpiryDate", userData?.iqamaExpiryDate)
          : setValue("iqamaExpiryDate", "");

        userData?.eid && setValue("eid", userData?.eid);
        new Date(userData?.eidExpiryDate) >= new Date() ||
        location?.pathname !== APP_ROUTES.INDIVIDUAL_VISIT_REQUEST
          ? setValue("eidExpiryDate", userData?.eidExpiryDate)
          : setValue("eidExpiryDate", "");

        userData?.passportNumber &&
          setValue("passportNumber", userData?.passportNumber);
        new Date(userData?.passportExpiryDate) >= new Date() ||
        location?.pathname !== APP_ROUTES.INDIVIDUAL_VISIT_REQUEST
          ? setValue("passportExpiryDate", userData?.passportExpiryDate)
          : setValue("passportExpiryDate", "");

        setValue("idTypeOtherName", userData?.idTypeOtherName || "");
        userData?.idTypeOtherNumber &&
          setValue("idTypeOtherNumber", userData?.idTypeOtherNumber);
        new Date(userData?.idTypeOtherExpiryDate) >= new Date() ||
        location?.pathname !== APP_ROUTES.INDIVIDUAL_VISIT_REQUEST
          ? setValue("idTypeOtherExpiryDate", userData?.idTypeOtherExpiryDate)
          : setValue("idTypeOtherExpiryDate", "");

        userData?.visa && setValue("visaNumber", userData?.visa);
        new Date(userData?.visaExpiryDate) >= new Date() ||
        location?.pathname !== APP_ROUTES.INDIVIDUAL_VISIT_REQUEST
          ? setValue("visaExpiryDate", userData?.visaExpiryDate)
          : setValue("visaExpiryDate", "");

        setValue("vehicleNo", userData?.vehicleNo || "");

        setValue("plateSource", userData?.plateSource || "");
        setValue("plateNumber", userData?.plateNumber || null);
        setValue("plateLetter1", userData?.plateLetter1 || "");
        setValue("plateLetter2", userData?.plateLetter2 || "");
        setValue("plateLetter3", userData?.plateLetter3 || "");

        if (appointment) {
          setValue("location", userData?.location || "");
          setValue("building", userData?.building || "");
          setValue("visitingDepartment", userData?.visitingDepartment || "");
          setValue("gate", userData?.gate || "");
          setValue("meetingRoom", userData?.meetingRoom || "");
          setValue("visitReqType", userData?.visitReqType || "");
          setValue("visitPurpose", userData?.visitPurpose || "");
          setValue("visitPurposeOther", userData?.visitPurposeOther || "");
          setValue("hostEmail", userData?.hostEmail || "");
          setValue("hostMobileNumber", userData?.hostMobileNumber || "");
          setValue("visitStartDate", userData?.visitStartDate || "");
          setValue("visitEndDate", userData?.visitEndDate || "");
          setValue("note", userData?.note || "");
          setValue("accessGroup", userData?.accessGroup || "");
          // setValue("reqAccessLevels", userData?.reqAccessLevels || "");
          // setValue("accessLevels", userData?.accessLevels || "");
        }
      }
    }
  }, [appointment, existingVisitorAppointment, location?.pathname, setValue]);

  const [isRejectAppointmentModalOpen, setIsRejectAppointmentModalOpen] =
    useState(false);
  const [isApproveAppointmentModalOpen, setIsApproveAppointmentModalOpen] =
    useState(false);

  const selectedVisitPurpose = watch("visitPurpose");

  const { data: dynamicWorkflow } = useGetDynamicWorkflowsByIdByNonAdmin(
    {
      encryptedId: DYNAMIC_WORKFLOW.DEVICES_APPROVAL_ONE_DAY_VISIT,
    },
    location.pathname === APP_ROUTES.INDIVIDUAL_VISIT_REQUEST
  );

  const [approveData, setApproveData] = useState<ApproveAppointmentBody>();

  const {
    mutateAsync: AddVisitorAppointment,
    isPending: isAddVisitorAppointmentLoading,
  } = useAddVisitorAppointment();

  const {
    mutateAsync: UpdateVisitorAppointment,
    isPending: isUpdateVisitorAppointmentLoading,
  } = useUpdateVisitorAppointment();

  const { mutateAsync: AddAttachment, isPending: isAddAttachmentLoading } =
    useAddAttachment();

  const { mutateAsync: RemoveAppointmentAttachment } =
    useRemoveAppointmentAttachment();

  const { mutateAsync: GetDeviceDetailsById } = useGetDeviceDetailsById();

  const {
    mutateAsync: CheckDuplicateAppointment,
    isPending: isCheckDuplicateAppointmentLoading,
  } = useCheckDuplicateAppointment();

  const { mutateAsync: ValidatePhoto, isPending: isValidatePhotoLoading } =
    useValidatePhoto();

  const { data: validatePhoto } = useGetValidatePhoto();

  const [isValidatePhoto, setIsValidatePhoto] = useState<boolean>(false);

  useEffect(() => {
    if (validatePhoto) {
      setIsValidatePhoto(validatePhoto.isValidatePhotoFromFR);
    }
  }, [validatePhoto]);

  const isVisitApprovedByNextApprover = useMemo(
    () =>
      !!(
        location.pathname === APP_ROUTES.UPDATE_REQUEST &&
        userAppointmentDetails?.currentApproverOrderNo &&
        userAppointmentDetails?.currentApproverOrderNo > 1
      ),
    [location.pathname, userAppointmentDetails?.currentApproverOrderNo]
  );

  const onReject = useCallback(async () => {
    if (
      // isVisitExpired ||
      // (isVisitExpired &&
      //   appointment?.appointment?.approvalStatus === STATUS_IDS.PENDING) ||

      appointment?.appointment?.approvalStatus === STATUS_IDS.EXPIRED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.CANCELED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.EXPIRED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.REJECTED
    ) {
      return;
    } else if (
      userAppointmentDetails?.visitEndDate &&
      new Date(userAppointmentDetails?.visitEndDate) <= new Date()
    ) {
      toast.error(t("visitExpiredCannotReject"));
      return;
    }

    setIsRejectAppointmentModalOpen(true);
  }, [
    appointment?.appointment?.approvalStatus,
    t,
    userAppointmentDetails?.visitEndDate,
  ]);

  const appointmentStartEndDateTimes = useMemo(
    () => ({
      visitStartDate: userAppointmentDetails?.visitStartDate,
      visitEndDate: userAppointmentDetails?.visitEndDate,
    }),
    [
      userAppointmentDetails?.visitEndDate,
      userAppointmentDetails?.visitStartDate,
    ]
  );

  const isVisitPurposeOther = useMemo(() => {
    const purpose =
      visitPurposes?.find((item) => item.value === Number(selectedVisitPurpose))
        ?.labelEn || "";

    return purpose.trim() === "Other";
  }, [visitPurposes, selectedVisitPurpose]);

  const isApproveDisabled = useMemo(
    () =>
      appointment?.appointment?.approvalStatus === STATUS_IDS.EXPIRED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.APPROVED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.CANCELED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.EXPIRED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.REJECTED ||
      // not fully approved -> only current approver can approve
      (appointment?.appointment?.approvalStatus !== STATUS_IDS.APPROVED &&
        user?.n_RoleID !==
          appointment?.appointmentNextApprover
            ?.n_AppointmentNextApproverRoleID),
    [
      appointment?.appointment?.approvalStatus,
      appointment?.appointmentNextApprover?.n_AppointmentNextApproverRoleID,
      user?.n_RoleID,
    ]
  );

  const isReqInfoDeviceCommentMissing = useMemo(
    () =>
      addedDevices?.some(
        (item) =>
          item.currentUserDeviceStatus === STATUS_IDS.REQUEST_INFO &&
          !item.comment
      ),
    [addedDevices]
  );

  const onApprove = useCallback(
    async (data: IndividualData) => {
      if (isApproveDisabled) {
        return;
      }

      const isAppointmentWithinVisitingHours = isVisitWithinVisitingHours(
        data.visitStartDate,
        data.visitEndDate,
        visitingHours
      );

      if (isReqInfoDeviceCommentMissing) {
        toast.error(t("provideCommentsAllRequestedInfoDevices"));
      } else if (new Date(data.visitEndDate) <= new Date()) {
        toast.error(t("visitExpiredCannotApproved"));
      } else if (new Date(data.visitEndDate) <= new Date(data.visitStartDate)) {
        toast.error(t("visitDateError"));
      } else if (!isAppointmentWithinVisitingHours) {
        toast.error(
          t("vistingHoursAreFrom") +
            visitingHours.visitorsStartTime +
            t("to") +
            visitingHours.visitorsEndTime +
            "."
        );
      } else if (
        data.iqama &&
        data.idType === DOC_TYPE_ID.IQAMA &&
        onlyDate(data.iqama) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else if (
        data.eidExpiryDate &&
        data.idType === DOC_TYPE_ID.NATIONAL_ID &&
        onlyDate(data.eidExpiryDate) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else if (
        data.passportExpiryDate &&
        data.idType === DOC_TYPE_ID.PASSPORT &&
        onlyDate(data.passportExpiryDate) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else if (
        data.idTypeOtherExpiryDate &&
        data.idType === DOC_TYPE_ID.OTHER &&
        onlyDate(data.idTypeOtherExpiryDate) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else if (
        data.visaExpiryDate &&
        data.idType === DOC_TYPE_ID.VISA &&
        onlyDate(data.visaExpiryDate) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else {
        setIsApproveAppointmentModalOpen(true);
        const approveDataToSendAsBody = {
          n_AppointmentID: appointment?.appointment?.n_AppointmentID,
          s_AppointmentCode: appointment?.appointment?.s_AppointmentCode,
          n_LocationID: Number(data.location),
          n_VisitType: Number(data.visitReqType),
          purpose: Number(data.visitPurpose),
          PurposeOtherValue: isVisitPurposeOther ? data.visitPurposeOther : "",
          n_BuildingID: Number(data.building),
          n_DepartmentID: Number(data.visitingDepartment),
          n_GateID: Number(data.gate),
          n_MeetingRoomID: Number(data.meetingRoom),
          s_VisitingPersonEmail: data.hostEmail,
          s_HostMobileNo: data.hostMobileNumber,
          n_AccessGroupID: Number(data.accessGroup),
          N_IsAccessGroupUpdate:
            user?.n_RoleID === USER_ROLES_IDS.SECURITY ||
            user?.n_RoleID === USER_ROLES_IDS.SECURITY_MANAGER
              ? 1
              : 0,

          dt_AppointmentStartTime: formattedDateTime(
            new Date(data.visitStartDate)
          ),
          dt_AppointmentEndTime: formattedDateTime(new Date(data.visitEndDate)),

          Devices: isDeviceDetails
            ? (addedDevices ?? []).map((item: Device) => ({
                appointmentDeviceId: item.appointmentDeviceId || 0,
                DeviceType: item.deviceType,
                DeviceTypeOthersValue: item.deviceTypeOther,
                DeviceModel: item.deviceModel,
                SerialNumber: item.serialNumber,
                // DevicePurpose: item.devicePurpose,
                Purpose: item.purpose,
                DevicePurposeOthersValue: item.devicePurposeOther,
                ApprovalStatus: item.approvalStatus || STATUS_IDS.PENDING,
                CurrentApprovalStatus: item.currentUserDeviceStatus
                  ? item.currentUserDeviceStatus !== STATUS_IDS.APPROVED
                    ? STATUS_IDS.PENDING
                    : item.currentUserDeviceStatus
                  : STATUS_IDS.PENDING,
                Comment: item.comment,
              }))
            : null,

          N_PlateSource: isVehicleInfoVisible ? Number(data.plateSource) : 0,
          S_PlateCode: isVehicleInfoVisible ? data.plateCode : "",
          S_PlateNumber: isVehicleInfoVisible ? data.plateNumber : 0,
          N_PlateLetter1: isVehicleInfoVisible ? Number(data.plateLetter1) : 0,
          N_PlateLetter2: isVehicleInfoVisible ? Number(data.plateLetter2) : 0,
          N_PlateLetter3: isVehicleInfoVisible ? Number(data.plateLetter3) : 0,

          n_HostID: appointment?.appointment?.n_HostID,
          s_HostComments: appointment?.appointment?.s_HostComments,
          n_Approved_Host: appointment?.appointment?.n_Approved_Host,
          n_Approved_Security: appointment?.appointment?.n_Approved_Security,
          dt_CreatedDate_Staff: null,
          dt_UpdatedDate_Staff: null,
          dt_CreatedDate_External: null,
          dt_UpdatedDate_External: null,
          approvalStatus: STATUS_IDS.APPROVED,
          s_GroupKey: appointment?.appointment?.s_GroupKey,
          userId: user?.user_id,
          s_VisitorName_En: data.name,
          s_Sponsor: data.companyName,
          s_MobileNo: data.number,
          s_Email: data.email,
          n_IsExternalAppointment:
            appointment?.appointment?.n_IsExternalAppointment || 0,

          n_DocumentType: data.idType,
          s_Iqama:
            data.idType === DOC_TYPE_ID.IQAMA && data.iqama ? data.iqama : "",
          dt_IqamaExpiry:
            data.iqamaExpiryDate && data.idType === DOC_TYPE_ID.IQAMA
              ? formattedDate(new Date(data.iqamaExpiryDate), true)
              : null,
          eidNumber:
            data.idType === DOC_TYPE_ID.NATIONAL_ID && data.eid ? data.eid : "",
          dt_EIDExpiryDate:
            data.eidExpiryDate && data.idType === DOC_TYPE_ID.NATIONAL_ID
              ? formattedDate(new Date(data.eidExpiryDate), true)
              : null,
          passportNumber:
            data.idType === DOC_TYPE_ID.PASSPORT && data.passportNumber
              ? data.passportNumber
              : "",
          dt_PassportExpiryDate:
            data.passportExpiryDate && data.idType === DOC_TYPE_ID.PASSPORT
              ? formattedDate(new Date(data.passportExpiryDate), true)
              : null,
          s_OthersDoc:
            data.idType === DOC_TYPE_ID.OTHER ? data.idTypeOtherName : "",
          s_OthersValue:
            data.idType === DOC_TYPE_ID.OTHER && data.idTypeOtherNumber
              ? data.idTypeOtherNumber
              : "",
          dt_OthersExpiry:
            data.idTypeOtherExpiryDate && data.idType === DOC_TYPE_ID.OTHER
              ? formattedDate(new Date(data.idTypeOtherExpiryDate), true)
              : null,

          s_VisaNo:
            data.idType === DOC_TYPE_ID.VISA && data.visaNumber
              ? data.visaNumber
              : "",
          dt_VisaExpiryDate:
            data.visaExpiryDate && data.idType === DOC_TYPE_ID.VISA
              ? formattedDate(new Date(data.visaExpiryDate), true)
              : null,

          s_HostName: appointment?.appointment?.s_HostName,
          s_ApprovalNumber: appointment?.appointment?.s_ApprovalNumber,
          s_VehicleNo: data.vehicleNo,
          n_ProcessID: appointment?.appointment?.n_ProcessID,

          n_SelfPass: appointment?.appointment?.n_SelfPass,
          n_IsMobileAllowed:
            user?.n_RoleID === USER_ROLES_IDS.SECURITY
              ? isMobileAllowed
                ? 1
                : 0
              : appointment?.appointment?.n_IsMobileAllowed,
          n_IsLaptopAllowed:
            user?.n_RoleID === USER_ROLES_IDS.SECURITY
              ? isLaptopAllowed
                ? 1
                : 0
              : appointment?.appointment?.n_IsLaptopAllowed,
          s_AllowedReason: appointment?.appointment?.s_AllowedReason,
          // s_HostAccessAreasIDs: data.reqAccessLevels,
          // S_MaxAccessLevelIDs: data.accessLevels || null,
          s_Remarks: data.note,
          Nationality: data.nationality,

          N_RoleID: user?.n_RoleID,
          N_NextDevicesApproverRoleId:
            appointment?.appointment?.n_NextDevicesApproverRoleId,
          N_IsDevicesUpdate: user?.n_RoleID === USER_ROLES_IDS.STAFF ? 1 : 0,
          uploadHostEmployeeCard: data.uploadHostEmployeeCard,
          hostEmployeeCardFileType: hostEmployeeCardFileType,
        };

        setApproveData(approveDataToSendAsBody);
      }
    },
    [
      isApproveDisabled,
      visitingHours,
      isReqInfoDeviceCommentMissing,
      t,
      appointment?.appointment?.n_AppointmentID,
      appointment?.appointment?.s_AppointmentCode,
      appointment?.appointment?.n_HostID,
      appointment?.appointment?.s_HostComments,
      appointment?.appointment?.n_Approved_Host,
      appointment?.appointment?.n_Approved_Security,
      appointment?.appointment?.s_GroupKey,
      appointment?.appointment?.n_IsExternalAppointment,
      appointment?.appointment?.s_HostName,
      appointment?.appointment?.s_ApprovalNumber,
      appointment?.appointment?.n_ProcessID,
      appointment?.appointment?.n_SelfPass,
      appointment?.appointment?.n_IsMobileAllowed,
      appointment?.appointment?.n_IsLaptopAllowed,
      appointment?.appointment?.s_AllowedReason,
      appointment?.appointment?.n_NextDevicesApproverRoleId,
      isVisitPurposeOther,
      user?.n_RoleID,
      user?.user_id,
      isDeviceDetails,
      addedDevices,
      isVehicleInfoVisible,
      isMobileAllowed,
      isLaptopAllowed,
      hostEmployeeCardFileType,
    ]
  );

  const isUserAppointmentApprover = useMemo(
    () =>
      appointment?.appointmentNextApprover?.n_AppointmentNextApproverRoleID ===
      user?.n_RoleID,
    [
      appointment?.appointmentNextApprover?.n_AppointmentNextApproverRoleID,
      user?.n_RoleID,
    ]
  );

  const { data: photoUploaded } = useGetFileByTypeQuery({
    Id: appointment?.appointment?.n_AppointmentID,
    Type: ATTACHMENTS_TYPE.PHOTO,
  });

  const isSubmitDisabled = useMemo(
    () =>
      appointment?.appointment?.approvalStatus === STATUS_IDS.EXPIRED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.CANCELED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.EXPIRED ||
      appointment?.appointment?.approvalStatus === STATUS_IDS.REJECTED ||
      // fully approved -> only staff can update
      appointment?.appointment?.approvalStatus === STATUS_IDS.APPROVED ||
      // not fully approved -> only staff can update
      (appointment?.appointment?.approvalStatus !== STATUS_IDS.APPROVED &&
        user?.n_RoleID !== USER_ROLES_IDS.STAFF),
    [appointment?.appointment?.approvalStatus, user?.n_RoleID]
  );

  const handleDevicesApproval = useCallback(
    async (
      appointmentId: string,
      devices: Device[],
      visitStartDate: string,
      visitEndDate: string
    ) => {
      if (appointmentId) {
        try {
          const body = {
            EncryptedId: appointmentId.toString(),
            n_RoleID: user?.n_RoleID,
            approvalDevices: devices?.map((item: Device) => ({
              appointmentDeviceId: item.appointmentDeviceId,
              N_ApprovalStatus: item.approvalStatus || 0,
              N_CurrentApprovalStatus: item.currentUserDeviceStatus || 0,
            })),
            Dt_AppointmentStartTime: visitStartDate,
            Dt_AppointmentEndTime: visitEndDate,
          };

          await ApproveDevices(body);
        } catch (error) {
          toast.error(t("somethingWentWrong"));
          return;
        }
      }
    },
    [user?.n_RoleID, ApproveDevices, t]
  );

  const onSubmit = useCallback(
    async (data: IndividualData) => {
      if (isSubmitDisabled) {
        return;
      }

      const isAppointmentWithinVisitingHours = isVisitWithinVisitingHours(
        data.visitStartDate,
        data.visitEndDate,
        visitingHours
      );

      if (
        location.pathname === APP_ROUTES.UPDATE_REQUEST &&
        isReqInfoDeviceCommentMissing
      ) {
        toast.error(t("provideCommentsAllRequestedInfoDevices"));
      } else if (new Date(data.visitEndDate) <= new Date(data.visitStartDate)) {
        toast.error(t("visitDateError"));
      } else if (!isAppointmentWithinVisitingHours) {
        toast.error(
          t("vistingHoursAreFrom") +
            visitingHours.visitorsStartTime +
            t("to") +
            visitingHours.visitorsEndTime +
            "."
        );
      } else if (
        data.iqama &&
        data.idType === DOC_TYPE_ID.IQAMA &&
        onlyDate(data.iqama) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else if (
        data.eidExpiryDate &&
        data.idType === DOC_TYPE_ID.NATIONAL_ID &&
        onlyDate(data.eidExpiryDate) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else if (
        data.passportExpiryDate &&
        data.idType === DOC_TYPE_ID.PASSPORT &&
        onlyDate(data.passportExpiryDate) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else if (
        data.idTypeOtherExpiryDate &&
        data.idType === DOC_TYPE_ID.OTHER &&
        onlyDate(data.idTypeOtherExpiryDate) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else if (
        data.visaExpiryDate &&
        data.idType === DOC_TYPE_ID.VISA &&
        onlyDate(data.visaExpiryDate) < onlyDate(data.visitEndDate)
      ) {
        toast.error(t("expireVisitError"));
      } else if (
        isDeviceDetails &&
        (!addedDevices || addedDevices?.length === 0)
      ) {
        toast.error(t("kindlyAddADevice"));
      } else {
        let isPhotoValid = false;

        let base64String =
          data.uploadPhoto && (await fileToBase64(data.uploadPhoto));

        // Check for Exisitng Record attachment e.g havePhoto = 1
        base64String = data.uploadPhoto
          ? base64String
          : photoUploaded?.photoFile;

        // Validate Photo from FR only if isValidatePhoto is enabled + Photo is attached/uploaded
        if (data.uploadPhoto && isValidatePhoto && base64String) {
          try {
            const body = {
              fullName: data.name,
              photo: base64String,
              // photo: data.uploadPhoto ? base64String : photoUploaded?.photoFile,
            };

            const res = await ValidatePhoto(body);
            isPhotoValid = res.isPhotoValid;
          } catch (error: any) {
            const { result } = error;
            const errorCode = result.photoErrors[0]?.errorCode;

            const errorMessages: Record<string, string> = {
              [INVALID_PHOTO_ERRORS.PHOTO_VALIDATION_FAILED]: t(
                "photoValidationFailed"
              ),
              [INVALID_PHOTO_ERRORS.PICTURE_FORMAT_ERROR]: t(
                // "The uploaded file format is not supported."
                "errorValidatingPhoto"
              ),
              [INVALID_PHOTO_ERRORS.WRONG_SIZE]: t("photoSizeIncorrect"),
              [INVALID_PHOTO_ERRORS.PICTURE_SIZE_TOO_SMALL]: t("photoTooSmall"),
              [INVALID_PHOTO_ERRORS.RESOLUTION_NO_SUPPORT]: t(
                "photoResolutionNotSupported"
              ),
              [INVALID_PHOTO_ERRORS.FACE_QUALITY_NOT_OK]: t("faceQualityNotOk"),
              [INVALID_PHOTO_ERRORS.NO_PICTURE]: t("noPhotoUploaded"),
              [INVALID_PHOTO_ERRORS.NO_FACE]: t("noFaceDetectedPhoto"),
              [INVALID_PHOTO_ERRORS.MULTIPLE_FACES_DETECTED]: t(
                "multipleFacesDetected"
              ),
              [INVALID_PHOTO_ERRORS.FACE_TOO_SMALL]: t("faceTooSmallPhoto"),
              [INVALID_PHOTO_ERRORS.PICTURE_TOO_BRIGHT]: t("photoTooBright"),
              [INVALID_PHOTO_ERRORS.PICTURE_TOO_DARK]: t("photoTooDark"),
              [INVALID_PHOTO_ERRORS.FACE_TOO_BLUR]: t("faceTooBlurry"),
              [INVALID_PHOTO_ERRORS.WRONG_FACE_POSE]: t(
                "faceNotProperlyAligned"
              ),
              [INVALID_PHOTO_ERRORS.DUPLICATE_FACE_IMAGE]:
                t("photoAlreadyUsed"),
              [INVALID_PHOTO_ERRORS.DUPLICATE_FACE_NUMBER]: t(
                "photoFaceAlreadyExists"
              ),
              [INVALID_PHOTO_ERRORS.DUPLICATE_FACE_NAME]: t(
                "faceAlreadyRegisteredSameName"
              ),
            };

            toast.error(errorMessages[errorCode] ?? t("somethingWentWrong"));
            return;
          }
        } else if (visitReqType == VisitorType.VVIP) {
          // For VIPs Photo is Optional so incase of No Photo bypass the Validate Photo from FR
          isPhotoValid = true;
        } 
        // else if (!data.uploadPhoto && isValidatePhoto) {
        //   toast.error(t("photoUploadRequired"));
        //   return;
        // }

        if (data.uploadPhoto && isValidatePhoto && !isPhotoValid) {
          return;
        }
        
          try {
            if (user?.user_id && visitReqType != VisitorType.VVIP) {
              const body = {
                N_AppointmentID: key ? Number(key) : 0,

                N_ExternalRegistrationID: 0,
                N_LocationID: Number(data.location),
                N_BuildingID: Number(data.building),
                S_Iqama:
                  data.iqama && data.idType === DOC_TYPE_ID.IQAMA
                    ? data.iqama
                    : "",
                S_EIDNumber:
                  data.eid && data.idType === DOC_TYPE_ID.NATIONAL_ID
                    ? data.eid
                    : "",
                S_PassportNumber:
                  data.passportNumber && data.idType === DOC_TYPE_ID.PASSPORT
                    ? data.passportNumber
                    : "",
                S_OthersValue:
                  data.idTypeOtherNumber && data.idType === DOC_TYPE_ID.OTHER
                    ? data.idTypeOtherNumber
                    : "",
                S_VisaNo:
                  data.visaNumber && data.idType === DOC_TYPE_ID.VISA
                    ? data.visaNumber
                    : "",

                D_FromDate: formattedDateTime(new Date(data.visitStartDate)),
                D_ToDate: formattedDateTime(new Date(data.visitEndDate)),
              };
              const res = await CheckDuplicateAppointment(body);
              if (res.status) {
                toast.error(t("appointmentExists"));
                return;
              }
            }
          } catch (error) {
            toast.error(t("somethingWentWrong"));
            return;
          }

          try {
            const body = {
              N_VisitCreatedFrom: VISIT_CREATED_FROM.VMS,
              N_VisitUpdatedFrom: VISIT_CREATED_FROM.VMS,
              N_RoleID: user?.n_RoleID,
              FullName: data.name,
              Sponsor: data.companyName,
              MobileNo: data.number,
              Email: data.email,
              N_VisitType: Number(data.visitReqType),

              IDType: data.idType,
              S_Iqama:
                data.idType === DOC_TYPE_ID.IQAMA && data.iqama
                  ? data.iqama
                  : "",
              EIDNumber:
                data.idType === DOC_TYPE_ID.NATIONAL_ID && data.eid
                  ? data.eid
                  : "",
              PassportNumber:
                data.idType === DOC_TYPE_ID.PASSPORT && data.passportNumber
                  ? data.passportNumber
                  : "",
              S_OthersDoc:
                data.idType === DOC_TYPE_ID.OTHER ? data.idTypeOtherName : "",
              S_OthersValue:
                data.idType === DOC_TYPE_ID.OTHER && data.idTypeOtherNumber
                  ? data.idTypeOtherNumber
                  : "",
              S_VisaNo:
                data.idType === DOC_TYPE_ID.VISA && data.visaNumber
                  ? data.visaNumber
                  : "",

              Devices: isDeviceDetails
                ? addedDevices?.map((item: any) => ({
                    appointmentDeviceId: item.appointmentDeviceId || 0,
                    DeviceType: item.deviceType,
                    DeviceTypeOthersValue: item.deviceTypeOther,
                    DeviceModel: item.deviceModel,
                    SerialNumber: item.serialNumber,
                    // DevicePurpose: item.devicePurpose,
                    Purpose: item.purpose,
                    DevicePurposeOthersValue: item.devicePurposeOther,
                    ApprovalStatus: item.approvalStatus || STATUS_IDS.PENDING,
                    Comment: item.comment,
                  }))
                : null,

              Dt_IqamaExpiry:
                data.iqamaExpiryDate && data.idType === DOC_TYPE_ID.IQAMA
                  ? formattedDate(new Date(data.iqamaExpiryDate), true)
                  : null,
              Dt_EIDExpiryDate:
                data.eidExpiryDate && data.idType === DOC_TYPE_ID.NATIONAL_ID
                  ? formattedDate(new Date(data.eidExpiryDate), true)
                  : null,
              Dt_PassportExpiryDate:
                data.passportExpiryDate && data.idType === DOC_TYPE_ID.PASSPORT
                  ? formattedDate(new Date(data.passportExpiryDate), true)
                  : null,
              Dt_OthersExpiry:
                data.idTypeOtherExpiryDate && data.idType === DOC_TYPE_ID.OTHER
                  ? formattedDate(new Date(data.idTypeOtherExpiryDate), true)
                  : null,
              Dt_VisaExpiryDate:
                data.visaExpiryDate && data.idType === DOC_TYPE_ID.VISA
                  ? formattedDate(new Date(data.visaExpiryDate), true)
                  : null,
              Dt_DateOfBirth: data.dateOfBirth
                ? formattedDate(new Date(data.dateOfBirth), true)
                : null,
              Nationality: data.nationality,
              N_LocationID: Number(data.location),
              N_BuildingID: Number(data.building),
              N_DepartmentID: Number(data.visitingDepartment),
              n_GateID: Number(data.gate),
              n_MeetingRoomID: Number(data.meetingRoom),
              S_VisitingPersonEmail: data.hostEmail,
              S_HostMobileNo: data.hostMobileNumber,
              Dt_AppointmentStartTime: formattedDateTime(
                new Date(data.visitStartDate)
              ),
              Dt_AppointmentEndTime: formattedDateTime(
                new Date(data.visitEndDate)
              ),

              N_PlateSource: isVehicleInfoVisible
                ? Number(data.plateSource)
                : 0,
              S_PlateCode: isVehicleInfoVisible ? data.plateCode : "",
              S_PlateNumber: isVehicleInfoVisible ? data.plateNumber : 0,
              N_PlateLetter1: isVehicleInfoVisible
                ? Number(data.plateLetter1)
                : 0,
              N_PlateLetter2: isVehicleInfoVisible
                ? Number(data.plateLetter2)
                : 0,
              N_PlateLetter3: isVehicleInfoVisible
                ? Number(data.plateLetter3)
                : 0,

              ApprovalStatus: STATUS_IDS.PENDING,
              Purpose: Number(data.visitPurpose),
              // to change PurposeOtherValue
              PurposeOtherValue: isVisitPurposeOther
                ? data.visitPurposeOther
                : "",
              Remarks: data.note,
              S_GroupKey: "",
              user_id: user?.user_id,
              N_IsExternalAppointment: 0,
              N_CreatedBy_Staff: user?.user_id,
              N_UpdatedBy_Staff: user?.user_id,
              N_CreatedBy_External: 0,
              S_VehicleNo: data.vehicleNo,
              N_IsMobileAllowed: false,
              N_IsLaptopAllowed: false,
              S_AllowedReason: "",
              n_SelfPass: visitReqType != VisitorType.VVIP ? 1 : 3,
              ReSubmissionComment: data.resubmissionComment,
            };

            let res;

            if (!key) {
              res = await AddVisitorAppointment(body);
            } else {
              const updateBody = {
                ...body,
                N_AppointmentID: Number(key),
                n_SelfPass: appointment?.appointment?.n_SelfPass,
                N_IsExternalAppointment:
                  appointment?.appointment?.n_IsExternalAppointment || 0,
                N_IsMobileAllowed: appointment?.appointment?.n_IsMobileAllowed,
                N_IsLaptopAllowed: appointment?.appointment?.n_IsLaptopAllowed,
                S_AllowedReason: appointment?.appointment?.s_AllowedReason,
              };

              res = await UpdateVisitorAppointment(updateBody);
            }

            if (res) {
              const appointmentID = res.id;

              const attachmentBodies: AddAttachments[] = [
                {
                  Id: appointmentID,
                  File: data.uploadPhoto,
                  S_FileType: photoFileType,
                  S_FileFieldName: "S_PhotoUpload",
                  S_FiledFileType: "S_PhotoContentType",
                },
                {
                  Id: appointmentID,
                  File:
                    data.idType === DOC_TYPE_ID.IQAMA ? data.uploadIqama : "",
                  S_FileType:
                    data.idType === DOC_TYPE_ID.IQAMA ? iqamaFileType : "",
                  S_FileFieldName: "S_IqamaUpload",
                  S_FiledFileType: "S_IqamaContentType",
                },
                {
                  Id: appointmentID,
                  File:
                    data.idType === DOC_TYPE_ID.NATIONAL_ID
                      ? data.uploadEid
                      : "",
                  S_FileType:
                    data.idType === DOC_TYPE_ID.NATIONAL_ID ? eidFileType : "",
                  S_FileFieldName: "S_EIDFile",
                  S_FiledFileType: "S_EIDContentType",
                },
                {
                  Id: appointmentID,
                  File:
                    data.idType === DOC_TYPE_ID.PASSPORT
                      ? data.uploadPassport
                      : "",
                  S_FileType:
                    data.idType === DOC_TYPE_ID.PASSPORT
                      ? passportFileType
                      : "",
                  S_FileFieldName: "S_PassportFile",
                  S_FiledFileType: "S_PassportContentType",
                },
                {
                  Id: appointmentID,
                  File:
                    data.idType === DOC_TYPE_ID.OTHER ? data.uploadIdOther : "",
                  S_FileType:
                    data.idType === DOC_TYPE_ID.OTHER ? idOtherFileType : "",
                  S_FileFieldName: "S_OthersUpload",
                  S_FiledFileType: "S_OthersContentType",
                },
                {
                  Id: appointmentID,
                  File: data.idType === DOC_TYPE_ID.VISA ? data.uploadVisa : "",
                  S_FileType:
                    data.idType === DOC_TYPE_ID.VISA ? visaFileType : "",
                  S_FileFieldName: "S_VisaFile",
                  S_FiledFileType: "S_VisaContentType",
                },
                {
                  Id: appointmentID,
                  File: data.uploadVehicleRegLicense,
                  S_FileType: vehicleRegLicenseFileType,
                  S_FileFieldName: "S_VehicleRegistrationFile",
                  S_FiledFileType: "S_VehicleRegistrationContentType",
                },
                {
                  Id: appointmentID,
                  File: data.uploadHostEmployeeCard,
                  S_FileType: hostEmployeeCardFileType,
                  S_FileFieldName: "S_HostEmployeeCardFile",
                  S_FiledFileType: "S_HostEmployeeCardContentType",
                },
              ];

              const formDatas = attachmentBodies.map((body) => {
                const formData = new FormData();
                formData.append("Id", body.Id.toString());
                formData.append("File", body.File ?? "");
                formData.append("S_FileType", body.S_FileType ?? "");
                formData.append("S_FileFieldName", body.S_FileFieldName);
                formData.append("S_FiledFileType", body.S_FiledFileType);
                return formData;
              });
              try {
                // eslint-disable-next-line array-callback-return
                const uploadPromises = formDatas.map((body, idx) => {
                  if (attachmentBodies[idx].File) {
                    AddAttachment(body);
                  }
                });
                await Promise.all(uploadPromises);
              } catch (error) {
                toast.error(t("somethingWentWrongAttachments"));
              }

              if (removedAttachments.length > 0 && appointmentID) {
                await Promise.all(
                  removedAttachments.map((attachment) =>
                    RemoveAppointmentAttachment({
                      id: Number(appointmentID),
                      S_FileFieldName: attachment.S_FileFieldName,
                      s_FiledFileType: attachment.s_FiledFileType,
                    })
                  )
                );
              }

              if (
                isDeviceDetails &&
                dynamicWorkflow?.[0].n_RoleID === user?.n_RoleID
              ) {
                const body = {
                  encryptedId: appointmentID,
                };
                const devices = await GetDeviceDetailsById(body);

                handleDevicesApproval(
                  appointmentID,
                  devices,
                  formattedDateTime(new Date(data.visitStartDate)),
                  formattedDateTime(new Date(data.visitEndDate))
                );
              }
            }

            if (!key) {
              toast.success(t("appointmentCreated"));
            } else {
              toast.success(t("appointmentUpdated"));
            }

            setTimeout(() => {
              navigate(APP_ROUTES.SEARCH_VISIT_REQUEST);
            }, 700);
          } catch (error: any) {
            const errorCode = error.errors && Object.keys(error.errors)[0];

            if (errorCode === API_ERRORS.MAX_ALLOWED_DAYS_EXCEEDED) {
              toast.error(t("maxAllowedDaysExceeded"));
            } else {
              toast.error(t("somethingWentWrong"));
            }
          }
      }
    },
    [
      isSubmitDisabled,
      visitingHours,
      location.pathname,
      isReqInfoDeviceCommentMissing,
      isDeviceDetails,
      addedDevices,
      t,
      photoUploaded?.photoFile,
      isValidatePhoto,
      visitReqType,
      ValidatePhoto,
      user?.user_id,
      user?.n_RoleID,
      key,
      CheckDuplicateAppointment,
      isVehicleInfoVisible,
      isVisitPurposeOther,
      AddVisitorAppointment,
      appointment?.appointment?.n_SelfPass,
      appointment?.appointment?.n_IsExternalAppointment,
      appointment?.appointment?.n_IsMobileAllowed,
      appointment?.appointment?.n_IsLaptopAllowed,
      appointment?.appointment?.s_AllowedReason,
      UpdateVisitorAppointment,
      photoFileType,
      iqamaFileType,
      eidFileType,
      passportFileType,
      idOtherFileType,
      visaFileType,
      vehicleRegLicenseFileType,
      hostEmployeeCardFileType,
      dynamicWorkflow,
      AddAttachment,
      RemoveAppointmentAttachment,
      removedAttachments,
      GetDeviceDetailsById,
      handleDevicesApproval,
      navigate,
    ]
  );

  const onRequestInfo = useCallback(() => {
    if (
      userAppointmentDetails?.visitEndDate &&
      new Date(userAppointmentDetails?.visitEndDate) <= new Date()
    ) {
      toast.error(t("visitExpiredCannotRequestInfo"));
    } else {
      setIsRequestMoreInfoModalOpen(true);
    }
  }, [t, userAppointmentDetails?.visitEndDate]);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-1 justify-between">
          <div className="flex items-center gap-2">
            <div className="flex gap-2 items-end">
              <h1 className="text-xl md:text-2xl dark:text-white">
                {location.pathname === APP_ROUTES.INDIVIDUAL_VISIT_REQUEST ||
                location.pathname === APP_ROUTES.GROUP_VISIT_REQUEST ? (
                  <>
                    {t("createVisitRequest")}{" "}
                    <span className="text-sm">({t("individual")})</span>
                  </>
                ) : location.pathname === APP_ROUTES.APPROVE_REQUEST ? (
                  t("approveVisitRequest")
                ) : (
                  t("updateVisitRequest")
                )}
              </h1>
            </div>
            {appointment &&
              appointment?.appointment?.approvalStatus !==
                STATUS_IDS.PENDING && (
                <p
                  className={cn(
                    "text-[13px]",
                    appointment?.appointment?.approvalStatus ===
                      STATUS_IDS.APPROVED
                      ? "text-green-600"
                      : appointment?.appointment?.approvalStatus ===
                        STATUS_IDS.REQUEST_INFO
                      ? "text-purple-tertiary"
                      : "text-red-600"
                  )}
                >
                  (
                  {i18n.language === "en"
                    ? appointment?.appointment?.s_ApprovalStatusEn
                    : appointment?.appointment?.s_ApprovalStatusAr}
                  )
                </p>
              )}
          </div>

          <div className="flex items-center gap-2">
            {location.pathname === APP_ROUTES.APPROVE_REQUEST ? (
              <Button
                type="button"
                onClick={() => navigate(APP_ROUTES.APPROVE_VISIT_REQUEST)}
                className="max-w-max bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:!ring-white dark:text-white"
              >
                {t("approveVisitRequests")}
              </Button>
            ) : user?.n_RoleID !== USER_ROLES_IDS.SECURITY ? (
              <Button
                type="button"
                onClick={() => navigate(APP_ROUTES.SEARCH_VISIT_REQUEST)}
                className="max-w-max bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:!ring-white dark:text-white"
              >
                {t("searchVisitRequests")}
              </Button>
            ) : (
              <></>
            )}
            <BackButton />
          </div>
        </div>

        {(location.pathname === APP_ROUTES.APPROVE_REQUEST ||
          (location.pathname === APP_ROUTES.UPDATE_REQUEST &&
            user?.n_RoleID === USER_ROLES_IDS.STAFF)) && <CommentsDrawer />}

        {location.pathname === APP_ROUTES.INDIVIDUAL_VISIT_REQUEST && (
          <SearchExistingVisitorInfoCard
            setExistingVisitorAppointment={setExistingVisitorAppointment}
            setIsLoading={setIsLoading}
          />
        )}

        {(key && isAppointmentLoading) || isLoading ? (
          <div className="flex justify-center">
            <Loader />
          </div>
        ) : (
          <>
            <VisitorDetailsCard
              selectedIdType={selectedIdType}
              control={control}
              errors={errors}
              userAppointmentDetails={userAppointmentDetails}
              isVIP={visitReqType == VisitorType.VVIP}
              isVehicleInfoVisible={isVehicleInfoVisible}
              setIsVehicleInfoVisible={setIsVehicleInfoVisible}
            />

            {isVehicleInfoVisible && (
              <VehicleInformationCard
                control={control}
                errors={errors}
                userAppointmentDetails={userAppointmentDetails}
                clearErrors={clearErrors}
                isVehicleInfoVisible={isVehicleInfoVisible}
              />
            )}

            <VisitDetailsCard
              control={control}
              errors={errors}
              userAppointmentDetails={userAppointmentDetails}
              clearErrors={clearErrors}
              isVIP={visitReqType == VisitorType.VVIP}
              isMobileAllowed={isMobileAllowed}
              setIsMobileAllowed={setIsMobileAllowed}
              isLaptopAllowed={isLaptopAllowed}
              setIsLaptopAllowed={setIsLaptopAllowed}
              visitStartDate={visitStartDate}
              visitEndDate={visitEndDate}
              setValue={setValue}
              visitPurposes={visitPurposes}
              isVisitPurposeOther={isVisitPurposeOther}
              nextApproverRoleId={
                appointment?.appointmentNextApprover
                  ?.n_AppointmentNextApproverRoleID
              }
              isDeviceDetails={isDeviceDetails}
              setIsDeviceDetails={setIsDeviceDetails}
              cardNumber={isVehicleInfoVisible ? 3 : 2}
              visitAllowedDuration={visitAllowedDuration}
              viewType={viewType}
            />

            {isDeviceDetails && (
              <DeviceDetailsCard
                clearErrors={clearErrors}
                userAppointmentDetails={userAppointmentDetails}
                addedDevices={addedDevices}
                setAddedDevices={setAddedDevices}
                isSubmitDisabled={isSubmitDisabled}
                nextApproverRoleId={
                  appointment?.appointmentNextApprover
                    ?.n_AppointmentNextApproverRoleID
                }
                cardNumber={isVehicleInfoVisible ? 4 : 3}
              />
            )}

            <AttachmentsCard
              control={control}
              errors={errors}
              selectedIdType={selectedIdType}
              uploadPhotoRef={uploadPhotoRef}
              photoFileName={photoFileName}
              setPhotoFileName={setPhotoFileName}
              setPhotoFileType={setPhotoFileType}
              uploadEidRef={uploadEidRef}
              eidFileName={eidFileName}
              setEidFileName={setEidFileName}
              setEidFileType={setEidFileType}
              uploadPassportRef={uploadPassportRef}
              passportFileName={passportFileName}
              setPassportFileName={setPassportFileName}
              setPassportFileType={setPassportFileType}
              uploadVisaRef={uploadVisaRef}
              visaFileName={visaFileName}
              setVisaFileName={setVisaFileName}
              setVisaFileType={setVisaFileType}
              uploadIqamaRef={uploadIqamaRef}
              iqamaFileName={iqamaFileName}
              setIqamaFileName={setIqamaFileName}
              setIqamaFileType={setIqamaFileType}
              uploadIdOtherRef={uploadIdOtherRef}
              idOtherFileName={idOtherFileName}
              setIdOtherFileName={setIdOtherFileName}
              setIdOtherFileType={setIdOtherFileType}
              userAppointmentDetails={userAppointmentDetails}
              isVIP={visitReqType == VisitorType.VVIP}
              uploadVehicleRegLicenseRef={uploadVehicleRegLicenseRef}
              setVehicleRegLicenseFileName={setVehicleRegLicenseFileName}
              setVehicleRegLicenseFileType={setVehicleRegLicenseFileType}
              vehicleRegLicenseFileName={vehicleRegLicenseFileName}
              uploadHostEmployeeCardRef={uploadHostEmployeeCardRef}
              hostEmployeeCardFileName={hostEmployeeCardFileName}
              setHostEmployeeCardFileName={setHostEmployeeCardFileName}
              setHostEmployeeCardFileType={setHostEmployeeCardFileType}
              isAttachments={isAttachments}
              onAttachmentRemoved={(info) => {
                setRemovedAttachments((prev) => [...prev, info]);
                const fieldMap: Record<string, keyof typeof isAttachments> = {
                  S_PhotoUpload: "havePhoto",
                  S_IqamaUpload: "haveIqama",
                  S_EIDFile: "haveEid",
                  S_PassportFile: "havePassport",
                  S_OthersUpload: "haveOthers",
                  S_VisaFile: "haveVisa",
                  S_VehicleRegistrationFile: "haveVehicleRegistration",
                  S_HostEmployeeCardFile: "haveHostEmployeeCard",
                };
                const field = fieldMap[info.S_FileFieldName];
                if (field) setIsAttachments((prev) => ({ ...prev, [field]: 0 }));
              }}
              cardNumber={
                isDeviceDetails && isVehicleInfoVisible
                  ? 5
                  : !isDeviceDetails && !isVehicleInfoVisible
                  ? 3
                  : 4
              }
            />

            {user?.n_RoleID === USER_ROLES_IDS.STAFF &&
              (key && isApprovalReq ? (
                <div className="flex flex-col gap-3 bg-white p-4 rounded-xl shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
                  <CheckboxInput
                    id="host-accompany-pledge"
                    label={t("hostAccompanyPledge")}
                    labelStyles="leading-[1.2]"
                    checked={
                      isHostAccompanyPledge ||
                      appointment?.appointment?.approvalStatus ===
                        STATUS_IDS.APPROVED ||
                      isApproveDisabled
                    }
                    setChecked={setIsHostAccompanyPledge}
                    readOnly={isApproveDisabled}
                  />
                </div>
              ) : (
                // create/update visit request
                <div className="flex flex-col gap-3 bg-white p-4 rounded-xl shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
                  <CheckboxInput
                    id="host-accompany-pledge"
                    label={t("hostAccompanyPledge")}
                    labelStyles="leading-[1.2]"
                    checked={isHostAccompanyPledge}
                    setChecked={setIsHostAccompanyPledge}
                    readOnly={isSubmitDisabled}
                  />
                </div>
              ))}

            {viewType !== VISIT_REQUEST_VIEW_TYPE.VIEW_ONLY && (
              <div className="flex justify-end gap-1">
                {key && user?.n_RoleID !== USER_ROLES_IDS.ADMIN && (
                  <>
                    {isApprovalReq ? (
                      <>
                        <Button
                          onClick={handleSubmit(onApprove)}
                          Icon={<Check className="w-4" />}
                          className="dark:bg-white dark:text-purple-primary hover:dark:text-purple-primary hover:dark:bg-white/80"
                          disabled={
                            (user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                              !isHostAccompanyPledge) ||
                            isApproveDisabled
                          }
                        >
                          {t("approve")}
                        </Button>
                        <Button
                          type="button"
                          onClick={onReject}
                          className="bg-red-600 hover:bg-red-700"
                          disabled={
                            appointment?.appointment?.approvalStatus ===
                              STATUS_IDS.EXPIRED ||
                            appointment?.appointment?.approvalStatus ===
                              STATUS_IDS.CANCELED ||
                            appointment?.appointment?.approvalStatus ===
                              STATUS_IDS.EXPIRED ||
                            appointment?.appointment?.approvalStatus ===
                              STATUS_IDS.REJECTED
                          }
                          Icon={<X className="w-4" />}
                        >
                          {t("reject")}
                        </Button>

                        {user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                        !userAppointmentDetails?.isExternalAppointment ? (
                          <></>
                        ) : (
                          <Button
                            className="bg-yellow-500 hover:bg-yellow-600"
                            disabled={isApproveDisabled}
                            onClick={onRequestInfo}
                            Icon={<CircleAlert className="w-4" />}
                          >
                            {t("requestInfo")}
                          </Button>
                        )}
                      </>
                    ) : (
                      <Button
                        onClick={handleSubmit(onSubmit)}
                        isLoading={
                          isValidatePhotoLoading ||
                          isCheckDuplicateAppointmentLoading ||
                          isAddVisitorAppointmentLoading ||
                          isUpdateVisitorAppointmentLoading ||
                          isAddAttachmentLoading
                        }
                        disabled={
                          !isHostAccompanyPledge ||
                          isSubmitDisabled ||
                          isVisitApprovedByNextApprover ||
                          isValidatePhotoLoading ||
                          isCheckDuplicateAppointmentLoading ||
                          isAddVisitorAppointmentLoading ||
                          isUpdateVisitorAppointmentLoading ||
                          isAddAttachmentLoading
                        }
                        className="dark:bg-white dark:text-purple-primary hover:dark:text-purple-primary hover:dark:bg-white/80"
                      >
                        {t("update")}
                      </Button>
                    )}
                  </>
                )}

                {!key && (
                  <Button
                    isLoading={
                      isValidatePhotoLoading ||
                      isCheckDuplicateAppointmentLoading ||
                      isAddVisitorAppointmentLoading ||
                      isUpdateVisitorAppointmentLoading ||
                      isAddAttachmentLoading ||
                      isApproveDevicesLoading
                    }
                    disabled={
                      !isHostAccompanyPledge ||
                      isSubmitDisabled ||
                      isVisitApprovedByNextApprover ||
                      isValidatePhotoLoading ||
                      isCheckDuplicateAppointmentLoading ||
                      isAddVisitorAppointmentLoading ||
                      isUpdateVisitorAppointmentLoading ||
                      isAddAttachmentLoading ||
                      isApproveDevicesLoading
                    }
                    onClick={handleSubmit(onSubmit)}
                    className="dark:bg-white dark:text-purple-primary hover:dark:text-purple-primary hover:dark:bg-white/80"
                  >
                    {t("submit")}
                  </Button>
                )}
              </div>
            )}
          </>
        )}
      </div>

      <RejectAppointmentModal
        appointment={appointment?.appointment}
        isOpen={isRejectAppointmentModalOpen}
        onOpenChange={() => setIsRejectAppointmentModalOpen(false)}
      />

      <ApproveAppointmentModal
        data={approveData}
        isOpen={isApproveAppointmentModalOpen}
        onOpenChange={() => setIsApproveAppointmentModalOpen(false)}
        isVehicleAllowedByPreviousRole={
          userAppointmentDetails?.isVehicleAllowed
        }
        addedDevices={addedDevices}
        isDevicesApproval={
          appointment?.appointment?.n_NextDevicesApproverRoleId ===
          user?.n_RoleID
        }
        appointmentId={userAppointmentDetails?.id}
        appointmentDateTime={appointmentStartEndDateTimes}
        isUserAppointmentApprover={isUserAppointmentApprover}
        approvalStatus={appointment?.appointment?.approvalStatus}
      />

      <RequestMoreInfoModal
        appointmentId={appointment?.appointment?.n_AppointmentID}
        isOpen={isRequestMoreInfoModalOpen}
        onOpenChange={() => setIsRequestMoreInfoModalOpen(false)}
        addedDevices={addedDevices}
        persistedDevices={persistedDevices}
        isDevicesApproval={
          appointment?.appointment?.n_NextDevicesApproverRoleId ===
          user?.n_RoleID
        }
        appointmentDateTime={appointmentStartEndDateTimes}
      />
    </>
  );
};

export default Individual;
